/**
 * Keyboard event handler for horizontal tabbed list navigation
 *
 * @param {Object} options - Configuration options
 * @param {number} options.currentIndex - The current active index
 * @param {number} options.totalItems - Total number of items in the list
 * @param {Function} options.onNavigate - Callback called when navigation occurs, receives (newIndex, event)
 * @param {boolean} [options.wrap=false] - Whether to wrap around at boundaries (true) or stop at boundaries (false)
 * @returns {Function} Keyboard event handler function
 */
export const horizontalTabbedListKeyboardNavigation = ({
    currentIndex,
    totalItems,
    onNavigate,
    wrap = false,
}) => {
    return (event) => {
        let newIndex = currentIndex;
        let shouldHandle = false;

        switch (event.key) {
            case 'ArrowLeft': {
                newIndex = currentIndex - 1;
                if (newIndex < 0) {
                    newIndex = wrap ? totalItems - 1 : 0;
                }
                shouldHandle = wrap || newIndex !== currentIndex;
                break;
            }
            case 'ArrowRight': {
                newIndex = currentIndex + 1;
                if (newIndex >= totalItems) {
                    newIndex = wrap ? 0 : totalItems - 1;
                }
                shouldHandle = wrap || newIndex !== currentIndex;
                break;
            }
            case 'Home': {
                newIndex = 0;
                shouldHandle = newIndex !== currentIndex;
                break;
            }
            case 'End': {
                newIndex = totalItems - 1;
                shouldHandle = newIndex !== currentIndex;
                break;
            }
            default:
                return;
        }

        if (shouldHandle) {
            event.preventDefault();
            event.stopPropagation();
            onNavigate(newIndex, event);
        }
    };
};
